import { render } from "./FollowupPaymentMethod.vue?vue&type=template&id=75125eec&scoped=true"
import script from "./FollowupPaymentMethod.vue?vue&type=script&lang=js"
export * from "./FollowupPaymentMethod.vue?vue&type=script&lang=js"

import "./FollowupPaymentMethod.vue?vue&type=style&index=0&id=75125eec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75125eec"]])

export default __exports__